function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.63 5.55a.49.49 0 01-.088-.971l.088-.008h3.519a7.123 7.123 0 00-9.228-.839 7.026 7.026 0 00-.068 11.383.49.49 0 01-.578.79 8.006 8.006 0 01.077-12.97 8.103 8.103 0 0110.359.811V.49c0-.24.173-.44.402-.482L15.2 0c.24 0 .44.173.482.402l.008.088v4.57c0 .028-.002.05-.005.073l.005-.072a.492.492 0 01-.027.16l-.006.017a.475.475 0 01-.074.13l-.013.014a.36.36 0 01-.044.045l-.018.015a.15.15 0 01-.02.016l-.031.02a.49.49 0 01-.018.01l.049-.03a.49.49 0 01-.112.061.372.372 0 01-.082.024h-.006a.4.4 0 01-.083.009L10.63 5.55z",
  fillRule: "evenodd"
});

function SvgActionRedoM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRedoM);
export default __webpack_public_path__ + "static/media/action-redo--m.ceeac206.svg";
export { ForwardRef as ReactComponent };